"use strict";

var _slicedToArray = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.langToLocale = exports.localeDefault = exports.languageIdDefault = exports.languageDefault = exports.languages = exports.listIso = exports.list = exports.getByValue = void 0;

exports.getByValue = function (m, searchValue) {
  var l = m.entries();
  var a = Array.from(l);
  return a.find(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        _k = _ref2[0],
        v = _ref2[1];

    return v === searchValue;
  });
};

exports.list = [{
  id: 1,
  name: 'en',
  iso2: 'en',
  iso3: 'eng',
  originalName: 'English'
}, {
  id: 2,
  name: 'fr',
  iso2: 'fr',
  iso3: 'fra',
  originalName: 'Français'
}, {
  id: 3,
  name: 'de',
  iso2: 'de',
  iso3: 'deu',
  originalName: 'Deutsch'
}, {
  id: 4,
  name: 'it',
  iso2: 'it',
  iso3: 'ita',
  originalName: 'Italiano'
}, {
  id: 5,
  name: 'es',
  iso2: 'es',
  iso3: 'spa',
  originalName: 'Español'
}, {
  id: 6,
  name: 'ru',
  iso2: 'ru',
  iso3: 'rus',
  originalName: 'Pусский'
}, {
  id: 7,
  name: 'pt',
  iso2: 'pt',
  iso3: 'por',
  originalName: 'Português'
}, {
  id: 8,
  name: 'ja',
  iso2: 'ja',
  iso3: 'jpn',
  originalName: '日本語'
}, {
  id: 9,
  name: 'zh',
  iso2: 'zh',
  iso3: 'zho',
  originalName: '中文'
}, {
  id: 10,
  name: 'ko',
  iso2: 'ko',
  iso3: 'kor',
  originalName: '한국어'
}, {
  id: 14,
  name: 'id',
  iso2: 'id',
  iso3: 'ind',
  originalName: 'Bahasa Indonesia'
}];
exports.listIso = exports.list.map(function (l) {
  return [l.id, l.iso2];
});
exports.languages = new Map(exports.listIso);
exports.languageDefault = process.env.I18N_LANGUAGE_DEFAULT || 'en';
exports.languageIdDefault = Number(process.env.I18N_LANGUAGE_ID_DEFAULT) || 1;
exports.localeDefault = {
  id: exports.languageIdDefault,
  name: exports.languageDefault
};

exports.langToLocale = function (lang) {
  var f = exports.listIso.find(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        _k = _ref4[0],
        v = _ref4[1];

    return v === lang;
  });

  if (f) {
    return {
      id: f[0],
      name: f[1]
    };
  }

  return exports.localeDefault;
};